import { render, staticRenderFns } from "./InvitationResponseButtons.vue?vue&type=template&id=625374c4&scoped=true&"
import script from "./InvitationResponseButtons.vue?vue&type=script&lang=js&"
export * from "./InvitationResponseButtons.vue?vue&type=script&lang=js&"
import style0 from "./InvitationResponseButtons.vue?vue&type=style&index=0&id=625374c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625374c4",
  null
  
)

export default component.exports